import React, {useState} from 'react';
import logo_125x103 from '../images/logo-125x103.png';
import {Button, Card, FormControl, InputGroup, Row} from 'react-bootstrap';
import {
    useGetCurrentUser2faQrCodeQuery,
    useGetCurrentUserQuery,
    useLazyCheckCurrentUserTotpCodeQuery
} from '../features/apiSlice';
import {setAuthTotpCode} from '../authStorage.js';
import PropTypes from 'prop-types';
import ErrorWidget from "../manager/widgets/ErrorWidget.jsx";

const TotpView = ({
    onSuccess,
}) => {
    const [totpCodeValue, setTotpCodeValue] = useState('');

    const {
        data: currentUser,
    } = useGetCurrentUserQuery();

    const [checkTotpCode, {
        isError: checkTotpCodeIsError,
        error: checkTotpCodeError,
    }] = useLazyCheckCurrentUserTotpCodeQuery();

    const {
        data: qrCodeUrl
    } = useGetCurrentUser2faQrCodeQuery(currentUser.id);

    return (
        <div id="view-login" className="login-page">
            <div className="login-box">
                <Card className="card-primary card-outline">
                    <Card.Header className="text-center">
                        <img src={logo_125x103} alt="IBMS" id="login-logo" />
                    </Card.Header>
                    <Card.Body>{!currentUser.isQrScanned && <>
                        <p className="login-box-msg">Сканирайте QR кода с вашето приложение за двуфакторна автентикация</p>
                        <p><img src={qrCodeUrl} alt="2faqrCode" /></p>
                        </>}
                        <p className="login-box-msg">Двустепенното удостоверяване (2FA)</p>
                        <div className="mb-3">
                        <InputGroup>
                            <InputGroup.Text>2FA код</InputGroup.Text>
                            <FormControl type="text" name="totpCode"
                                         onChange={e => setTotpCodeValue(e.target.value)} />
                        </InputGroup>
                        </div>
                        <Row>
                        <Button variant="success" onClick={async () => {
                            const verifyTotpCode = await checkTotpCode(totpCodeValue);
                            if (verifyTotpCode.data) {
                                setAuthTotpCode(totpCodeValue);
                                onSuccess && onSuccess();
                            }
                            else {
                                alert('Грешен 2FA код!');
                            }
                        }}>Потвърди
                        </Button>
                        </Row>
                        {checkTotpCodeIsError && <ErrorWidget error={checkTotpCodeError} />}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

TotpView.propTypes = {
    onSuccess: PropTypes.func,
};

export default TotpView;
